var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp40Active(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#146EB4;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.2,22.9c1.7,1.7,3.8,2.8,5.9,3.2c0.5,0.1,1,0.1,1.5,0.1c1.5,0,2.8-0.4,3.9-1.3c0.2-0.1,0.3-0.3,0.3-0.5 c0-0.2-0.1-0.4-0.2-0.5l-2.5-2.5c-0.3-0.3-0.7-0.3-1,0l-1.6,1.6c-2.7-1.1-4.9-3.2-6.2-5.9L16,16.6l1.6-1.6c0.3-0.3,0.3-0.7,0-1 l-2.5-2.5c-0.1-0.1-0.3-0.2-0.5-0.2c0,0,0,0,0,0c-0.2,0-0.4,0.1-0.5,0.3C13,13,12.6,15,13,17.1C13.4,19.2,14.5,21.2,16.2,22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.3,6.6C28.5,2.8,23.1,1,17.7,1.7C10,2.7,3.6,9,2.6,16.7C2,21.5,3.2,26.1,6.1,29.8L5,36.3 c-0.1,0.5,0.1,1,0.5,1.3c0.2,0.2,0.5,0.3,0.8,0.3c0.2,0,0.3,0,0.5-0.1l6.3-2.6c2.9,1.2,6.1,1.7,9.2,1.3l0,0c0,0,0,0,0,0l0,0 c7.9-1.1,14.2-7.5,15.1-15.4C38.1,15.7,36.2,10.4,32.3,6.6z M8.9,29.7c0.1-0.4,0-0.8-0.3-1.1c-2.7-3.2-3.9-7.3-3.3-11.5 C6.1,10.5,11.5,5.2,18,4.4c4.6-0.6,9.1,0.9,12.4,4.1v0c3.3,3.2,4.9,7.7,4.4,12.3c-0.7,6.7-6.1,12.1-12.8,13 c-2.8,0.4-5.7-0.1-8.3-1.3c-0.3-0.2-0.7-0.2-1.1,0L8,34.4L8.9,29.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp40Active);
export default __webpack_public_path__ + "static/media/whatsapp40-active.2a886cbc6620799417cb468b81ba5b34.svg";
export { ForwardRef as ReactComponent };